import React, { useEffect, useState } from "react";
import Scrollbar from "react-scrollbars-custom";
import { useMoodsContext } from "store/contexts/moodsContext";
import Loader from "components/Loader";
import userAvatar from "assets/img/user.svg";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import classNames from "classnames";
import { useTimelineContext } from "store/contexts/timelineContext";

var styles = {
  dialogTitle: {
    padding: "10px",
    textAlign: "center",
  },
  dailogHeaderReaction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  dialogHeader: {
    display: "flex",
    alignItems: "center",
  },
  showReaction: {
    width: "20px",
    height: "20px",
    marginBottom: "0px",
    cursor: "pointer",
  },
  userSelectedReaction: {
    width: "27px",
    height: "27px",
    marginBottom: "0px",
    padding: "5px",
    position: "absolute",
    left: "21px",
    top: "19px",
  },
  closeMoods: {
    width: "30px",
    cursor: "pointer",
    fill: "#a1a2a9",
  },
  dialogContent: {
    height: "450px",
    maxHeight: "450px",
    overflow: "auto",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    marginRight: "5px",
  },
  listItem: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 10px 0px 10px",
    margin: "5px",
  },
  userDetail: {
    display: "flex",
    gap: "10px",
    fontWeight: "400",
    alignItems: "center",
    position: "relative",
  },
  avatar: {
    minHeight: "30px",
    height: "40px",
    minWidth: "30px",
    width: "40px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  userFullName: {
    paddingLeft: "5px",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
  },
  allMoodText: {
    padding: "10px",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
  },
};

export default ({ listTask, dialogState, setDialogState, loading }) => {
  const classes = styles;
  const { buzzes } = useMoodsContext();
  const [headerReaction, setHeaderReaction] = useState([]);
  const [displayReactedUser, setReactedUsers] = useState();
  const { setHide } = useTimelineContext();
  const [activeOption, setActiveOption] = useState({
    id: 0,
    active: true,
  });

  const closeDialog = () => {
    setDialogState(false);
    setHide(false);
  };

  useEffect(() => {
    if (listTask?.reactions) {
      checkDuplicate();
      setReactedUsers([...listTask?.reactions]);
    }

    //eslint-disable-next-line
  }, [listTask]);

  function checkDuplicate() {
    var result = listTask?.reactions?.filter(
      (currentValue, index, listTaskReactionArray) =>
        listTaskReactionArray.findIndex(
          (each) => each.buzz_type_id === currentValue.buzz_type_id
        ) === index
    );

    setHeaderReaction(result);
  }

  const showRelatedUsers = (mood) => {
    setReactedUsers(
      listTask?.reactions.filter(
        (user) => user.buzz_type_id === mood.buzz_type_id
      )
    );

    var moodActive = {
      id: mood.buzz_type_id,
      active: true,
    };

    setActiveOption(moodActive);
  };

  const showAllUsers = () => {
    setReactedUsers(listTask?.reactions);

    var allMoodActive = {
      id: 0,
      active: true,
    };

    setActiveOption(allMoodActive);
  };

  return (
    <Modal
      open={dialogState}
      showCloseIcon={false}
      onClose={closeDialog}
      classNames={{
        modalContainer: "modalContainer",
        modal: "reactionModalPadding",
      }}
    >
      <div style={classes.dialogTitle}>
        <div style={classes.dailogHeaderReaction}>
          <div style={classes.dialogHeader}>
            <span
              className={classNames({
                activeReaction: activeOption?.id === 0 ? true : false,
              })}
              style={classes.allMoodText}
              onClick={showAllUsers}
            >
              All
            </span>
            {headerReaction?.map((response) => (
              <span
                key={response?.id}
                className={classNames({
                  activeReaction:
                    activeOption?.id === response?.buzz_type_id ? true : false,
                })}
                style={{ padding: "10px" }}
              >
                <img
                  key={response.id}
                  onClick={() => showRelatedUsers(response)}
                  style={classes.showReaction}
                  src={
                    buzzes[
                      buzzes.findIndex((buzzes) => {
                        return buzzes?.id === response?.buzz_type_id;
                      })
                    ].media
                  }
                  alt={`${response?.user?.full_name}`}
                />
              </span>
            ))}
          </div>
          <CloseIcon
            style={classes.closeMoods}
            autoFocus
            onClick={closeDialog}
          />
        </div>
      </div>
      <hr style={{ margin: "0" }} />
      <div style={classes.dialogContent}>
        <Scrollbar style={{ paddingRight: "10px" }}>
          <div style={classes.listContainer}>
            {loading && (
              <div style={classes.loader}>
                <Loader />
              </div>
            )}
            {displayReactedUser?.map((response) => (
              <div style={classes.listItem} key={response.id}>
                <div style={classes.userDetail}>
                  <img
                    alt={`${response?.user?.avatar}`}
                    style={classes.avatar}
                    src={response?.user?.avatar ?? userAvatar}
                  />
                  <span style={classes.userFullName}>
                    {response?.user?.full_name}
                  </span>
                  <img
                    style={classes.userSelectedReaction}
                    src={
                      buzzes[
                        buzzes.findIndex((buzzes) => {
                          return buzzes?.id === response?.buzz_type_id;
                        })
                      ].media
                    }
                    alt={`${response?.user?.full_name}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </Scrollbar>
      </div>
    </Modal>
  );
};
